/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Ledg API
 * API for managing financial activities and transactions
 * OpenAPI spec version: 2.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  AccountResponse,
  ActivityListResponse,
  ActivityResponse,
  ApiActivityGroup,
  AppConfigResponse,
  CreateAccountApiRequest,
  CreateActivityRequest,
  CreateOrUpdateJournalEntryRequest,
  ErrorResponse,
  ImportBrokerSyncRequest,
  ImportOperationResponse,
  ImportResponse,
  ApiImportStatementRequestSchema,
  JournalEntryResponse,
  SyncImportSourceRequest,
  UpdateAccountApiRequest,
  UpdateActivityRequest,
  UpdateUserSettingsRequest,
  UserSettingsResponse
} from './client.schemas'




/**
 * @summary List accounts for the authenticated user
 */
export const listAccounts = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AccountResponse[]>> => {
    
    return axios.default.get(
      `/v2/account`,options
    );
  }


export const getListAccountsQueryKey = () => {
    return [`/v2/account`] as const;
    }

    
export const getListAccountsQueryOptions = <TData = Awaited<ReturnType<typeof listAccounts>>, TError = AxiosError<void | ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccounts>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAccountsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccounts>>> = ({ signal }) => listAccounts({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAccounts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof listAccounts>>>
export type ListAccountsQueryError = AxiosError<void | ErrorResponse>

/**
 * @summary List accounts for the authenticated user
 */
export const useListAccounts = <TData = Awaited<ReturnType<typeof listAccounts>>, TError = AxiosError<void | ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccounts>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getListAccountsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Create a new account
 */
export const createAccount = (
    createAccountApiRequest: CreateAccountApiRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AccountResponse>> => {
    
    return axios.default.post(
      `/v2/account`,
      createAccountApiRequest,options
    );
  }



export const getCreateAccountMutationOptions = <TError = AxiosError<ErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccount>>, TError,{data: CreateAccountApiRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createAccount>>, TError,{data: CreateAccountApiRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAccount>>, {data: CreateAccountApiRequest}> = (props) => {
          const {data} = props ?? {};

          return  createAccount(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAccountMutationResult = NonNullable<Awaited<ReturnType<typeof createAccount>>>
    export type CreateAccountMutationBody = CreateAccountApiRequest
    export type CreateAccountMutationError = AxiosError<ErrorResponse | void>

    /**
 * @summary Create a new account
 */
export const useCreateAccount = <TError = AxiosError<ErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccount>>, TError,{data: CreateAccountApiRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof createAccount>>,
        TError,
        {data: CreateAccountApiRequest},
        TContext
      > => {

      const mutationOptions = getCreateAccountMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get a specific account by name
 */
export const getAccountByName = (
    name: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AccountResponse>> => {
    
    return axios.default.get(
      `/v2/account/by-name/${name}`,options
    );
  }


export const getGetAccountByNameQueryKey = (name: string,) => {
    return [`/v2/account/by-name/${name}`] as const;
    }

    
export const getGetAccountByNameQueryOptions = <TData = Awaited<ReturnType<typeof getAccountByName>>, TError = AxiosError<void | ErrorResponse>>(name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountByName>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountByNameQueryKey(name);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountByName>>> = ({ signal }) => getAccountByName(name, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(name), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountByName>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountByNameQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountByName>>>
export type GetAccountByNameQueryError = AxiosError<void | ErrorResponse>

/**
 * @summary Get a specific account by name
 */
export const useGetAccountByName = <TData = Awaited<ReturnType<typeof getAccountByName>>, TError = AxiosError<void | ErrorResponse>>(
 name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountByName>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAccountByNameQueryOptions(name,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get a specific account by ID
 */
export const getAccount = (
    accountId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AccountResponse>> => {
    
    return axios.default.get(
      `/v2/account/${accountId}`,options
    );
  }


export const getGetAccountQueryKey = (accountId: string,) => {
    return [`/v2/account/${accountId}`] as const;
    }

    
export const getGetAccountQueryOptions = <TData = Awaited<ReturnType<typeof getAccount>>, TError = AxiosError<void | ErrorResponse>>(accountId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountQueryKey(accountId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccount>>> = ({ signal }) => getAccount(accountId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(accountId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountQueryResult = NonNullable<Awaited<ReturnType<typeof getAccount>>>
export type GetAccountQueryError = AxiosError<void | ErrorResponse>

/**
 * @summary Get a specific account by ID
 */
export const useGetAccount = <TData = Awaited<ReturnType<typeof getAccount>>, TError = AxiosError<void | ErrorResponse>>(
 accountId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAccountQueryOptions(accountId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update an existing account
 */
export const updateAccount = (
    accountId: string,
    updateAccountApiRequest: UpdateAccountApiRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AccountResponse>> => {
    
    return axios.default.put(
      `/v2/account/${accountId}`,
      updateAccountApiRequest,options
    );
  }



export const getUpdateAccountMutationOptions = <TError = AxiosError<ErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccount>>, TError,{accountId: string;data: UpdateAccountApiRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateAccount>>, TError,{accountId: string;data: UpdateAccountApiRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAccount>>, {accountId: string;data: UpdateAccountApiRequest}> = (props) => {
          const {accountId,data} = props ?? {};

          return  updateAccount(accountId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAccountMutationResult = NonNullable<Awaited<ReturnType<typeof updateAccount>>>
    export type UpdateAccountMutationBody = UpdateAccountApiRequest
    export type UpdateAccountMutationError = AxiosError<ErrorResponse | void>

    /**
 * @summary Update an existing account
 */
export const useUpdateAccount = <TError = AxiosError<ErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccount>>, TError,{accountId: string;data: UpdateAccountApiRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateAccount>>,
        TError,
        {accountId: string;data: UpdateAccountApiRequest},
        TContext
      > => {

      const mutationOptions = getUpdateAccountMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Delete an account (soft delete)
 */
export const deleteAccount = (
    accountId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.delete(
      `/v2/account/${accountId}`,options
    );
  }



export const getDeleteAccountMutationOptions = <TError = AxiosError<void | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,{accountId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,{accountId: string}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAccount>>, {accountId: string}> = (props) => {
          const {accountId} = props ?? {};

          return  deleteAccount(accountId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAccountMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAccount>>>
    
    export type DeleteAccountMutationError = AxiosError<void | ErrorResponse>

    /**
 * @summary Delete an account (soft delete)
 */
export const useDeleteAccount = <TError = AxiosError<void | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,{accountId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteAccount>>,
        TError,
        {accountId: string},
        TContext
      > => {

      const mutationOptions = getDeleteAccountMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Create a new activity
 */
export const createActivity = (
    createActivityRequest: CreateActivityRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.post(
      `/v2/activities/create`,
      createActivityRequest,options
    );
  }



export const getCreateActivityMutationOptions = <TError = AxiosError<ErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createActivity>>, TError,{data: CreateActivityRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createActivity>>, TError,{data: CreateActivityRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createActivity>>, {data: CreateActivityRequest}> = (props) => {
          const {data} = props ?? {};

          return  createActivity(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateActivityMutationResult = NonNullable<Awaited<ReturnType<typeof createActivity>>>
    export type CreateActivityMutationBody = CreateActivityRequest
    export type CreateActivityMutationError = AxiosError<ErrorResponse | void>

    /**
 * @summary Create a new activity
 */
export const useCreateActivity = <TError = AxiosError<ErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createActivity>>, TError,{data: CreateActivityRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof createActivity>>,
        TError,
        {data: CreateActivityRequest},
        TContext
      > => {

      const mutationOptions = getCreateActivityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary List activity groups for the authenticated user
 */
export const listActivityGroups = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ApiActivityGroup[]>> => {
    
    return axios.default.get(
      `/v2/activities/groups`,options
    );
  }


export const getListActivityGroupsQueryKey = () => {
    return [`/v2/activities/groups`] as const;
    }

    
export const getListActivityGroupsQueryOptions = <TData = Awaited<ReturnType<typeof listActivityGroups>>, TError = AxiosError<void | ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivityGroups>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListActivityGroupsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listActivityGroups>>> = ({ signal }) => listActivityGroups({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listActivityGroups>>, TError, TData> & { queryKey: QueryKey }
}

export type ListActivityGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof listActivityGroups>>>
export type ListActivityGroupsQueryError = AxiosError<void | ErrorResponse>

/**
 * @summary List activity groups for the authenticated user
 */
export const useListActivityGroups = <TData = Awaited<ReturnType<typeof listActivityGroups>>, TError = AxiosError<void | ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivityGroups>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getListActivityGroupsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Create a new activity group
 */
export const createActivityGroup = (
    createActivityGroupBody: unknown, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ApiActivityGroup>> => {
    
    return axios.default.post(
      `/v2/activities/groups`,
      createActivityGroupBody,options
    );
  }



export const getCreateActivityGroupMutationOptions = <TError = AxiosError<ErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createActivityGroup>>, TError,{data: unknown}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createActivityGroup>>, TError,{data: unknown}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createActivityGroup>>, {data: unknown}> = (props) => {
          const {data} = props ?? {};

          return  createActivityGroup(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateActivityGroupMutationResult = NonNullable<Awaited<ReturnType<typeof createActivityGroup>>>
    export type CreateActivityGroupMutationBody = unknown
    export type CreateActivityGroupMutationError = AxiosError<ErrorResponse | void>

    /**
 * @summary Create a new activity group
 */
export const useCreateActivityGroup = <TError = AxiosError<ErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createActivityGroup>>, TError,{data: unknown}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof createActivityGroup>>,
        TError,
        {data: unknown},
        TContext
      > => {

      const mutationOptions = getCreateActivityGroupMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get a specific activity group by ID
 */
export const getActivityGroup = (
    groupId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ApiActivityGroup>> => {
    
    return axios.default.get(
      `/v2/activities/groups/${groupId}`,options
    );
  }


export const getGetActivityGroupQueryKey = (groupId: string,) => {
    return [`/v2/activities/groups/${groupId}`] as const;
    }

    
export const getGetActivityGroupQueryOptions = <TData = Awaited<ReturnType<typeof getActivityGroup>>, TError = AxiosError<void | ErrorResponse>>(groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityGroup>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivityGroupQueryKey(groupId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivityGroup>>> = ({ signal }) => getActivityGroup(groupId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(groupId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActivityGroup>>, TError, TData> & { queryKey: QueryKey }
}

export type GetActivityGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getActivityGroup>>>
export type GetActivityGroupQueryError = AxiosError<void | ErrorResponse>

/**
 * @summary Get a specific activity group by ID
 */
export const useGetActivityGroup = <TData = Awaited<ReturnType<typeof getActivityGroup>>, TError = AxiosError<void | ErrorResponse>>(
 groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityGroup>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetActivityGroupQueryOptions(groupId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Delete an activity group
 */
export const deleteActivityGroup = (
    groupId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.delete(
      `/v2/activities/groups/${groupId}`,options
    );
  }



export const getDeleteActivityGroupMutationOptions = <TError = AxiosError<void | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteActivityGroup>>, TError,{groupId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteActivityGroup>>, TError,{groupId: string}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteActivityGroup>>, {groupId: string}> = (props) => {
          const {groupId} = props ?? {};

          return  deleteActivityGroup(groupId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteActivityGroupMutationResult = NonNullable<Awaited<ReturnType<typeof deleteActivityGroup>>>
    
    export type DeleteActivityGroupMutationError = AxiosError<void | ErrorResponse>

    /**
 * @summary Delete an activity group
 */
export const useDeleteActivityGroup = <TError = AxiosError<void | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteActivityGroup>>, TError,{groupId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteActivityGroup>>,
        TError,
        {groupId: string},
        TContext
      > => {

      const mutationOptions = getDeleteActivityGroupMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get activities in a specific group
 */
export const getActivitiesInGroup = (
    groupId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ActivityResponse[]>> => {
    
    return axios.default.get(
      `/v2/activities/groups/${groupId}/activities`,options
    );
  }


export const getGetActivitiesInGroupQueryKey = (groupId: string,) => {
    return [`/v2/activities/groups/${groupId}/activities`] as const;
    }

    
export const getGetActivitiesInGroupQueryOptions = <TData = Awaited<ReturnType<typeof getActivitiesInGroup>>, TError = AxiosError<void | ErrorResponse>>(groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivitiesInGroup>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivitiesInGroupQueryKey(groupId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivitiesInGroup>>> = ({ signal }) => getActivitiesInGroup(groupId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(groupId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActivitiesInGroup>>, TError, TData> & { queryKey: QueryKey }
}

export type GetActivitiesInGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getActivitiesInGroup>>>
export type GetActivitiesInGroupQueryError = AxiosError<void | ErrorResponse>

/**
 * @summary Get activities in a specific group
 */
export const useGetActivitiesInGroup = <TData = Awaited<ReturnType<typeof getActivitiesInGroup>>, TError = AxiosError<void | ErrorResponse>>(
 groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivitiesInGroup>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetActivitiesInGroupQueryOptions(groupId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary List activities with extended filtering options
 */
export const listActivities = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ActivityListResponse>> => {
    
    return axios.default.get(
      `/v2/activities/list`,options
    );
  }


export const getListActivitiesQueryKey = () => {
    return [`/v2/activities/list`] as const;
    }

    
export const getListActivitiesQueryOptions = <TData = Awaited<ReturnType<typeof listActivities>>, TError = AxiosError<void | ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivities>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListActivitiesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listActivities>>> = ({ signal }) => listActivities({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listActivities>>, TError, TData> & { queryKey: QueryKey }
}

export type ListActivitiesQueryResult = NonNullable<Awaited<ReturnType<typeof listActivities>>>
export type ListActivitiesQueryError = AxiosError<void | ErrorResponse>

/**
 * @summary List activities with extended filtering options
 */
export const useListActivities = <TData = Awaited<ReturnType<typeof listActivities>>, TError = AxiosError<void | ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivities>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getListActivitiesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update an existing activity
 */
export const updateActivity = (
    activityId: string,
    updateActivityRequest: UpdateActivityRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.put(
      `/v2/activities/${activityId}`,
      updateActivityRequest,options
    );
  }



export const getUpdateActivityMutationOptions = <TError = AxiosError<ErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateActivity>>, TError,{activityId: string;data: UpdateActivityRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateActivity>>, TError,{activityId: string;data: UpdateActivityRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateActivity>>, {activityId: string;data: UpdateActivityRequest}> = (props) => {
          const {activityId,data} = props ?? {};

          return  updateActivity(activityId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateActivityMutationResult = NonNullable<Awaited<ReturnType<typeof updateActivity>>>
    export type UpdateActivityMutationBody = UpdateActivityRequest
    export type UpdateActivityMutationError = AxiosError<ErrorResponse | void>

    /**
 * @summary Update an existing activity
 */
export const useUpdateActivity = <TError = AxiosError<ErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateActivity>>, TError,{activityId: string;data: UpdateActivityRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateActivity>>,
        TError,
        {activityId: string;data: UpdateActivityRequest},
        TContext
      > => {

      const mutationOptions = getUpdateActivityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get application configuration
 */
export const getAppConfig = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AppConfigResponse>> => {
    
    return axios.default.get(
      `/v2/app_config`,options
    );
  }


export const getGetAppConfigQueryKey = () => {
    return [`/v2/app_config`] as const;
    }

    
export const getGetAppConfigQueryOptions = <TData = Awaited<ReturnType<typeof getAppConfig>>, TError = AxiosError<void | ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppConfig>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAppConfigQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppConfig>>> = ({ signal }) => getAppConfig({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAppConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAppConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getAppConfig>>>
export type GetAppConfigQueryError = AxiosError<void | ErrorResponse>

/**
 * @summary Get application configuration
 */
export const useGetAppConfig = <TData = Awaited<ReturnType<typeof getAppConfig>>, TError = AxiosError<void | ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppConfig>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAppConfigQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Sync from broker API
 */
export const syncFromBroker = (
    importBrokerSyncRequest: ImportBrokerSyncRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ImportResponse>> => {
    
    return axios.default.post(
      `/v2/imports/broker-sync`,
      importBrokerSyncRequest,options
    );
  }



export const getSyncFromBrokerMutationOptions = <TError = AxiosError<ErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncFromBroker>>, TError,{data: ImportBrokerSyncRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof syncFromBroker>>, TError,{data: ImportBrokerSyncRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncFromBroker>>, {data: ImportBrokerSyncRequest}> = (props) => {
          const {data} = props ?? {};

          return  syncFromBroker(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SyncFromBrokerMutationResult = NonNullable<Awaited<ReturnType<typeof syncFromBroker>>>
    export type SyncFromBrokerMutationBody = ImportBrokerSyncRequest
    export type SyncFromBrokerMutationError = AxiosError<ErrorResponse | void>

    /**
 * @summary Sync from broker API
 */
export const useSyncFromBroker = <TError = AxiosError<ErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncFromBroker>>, TError,{data: ImportBrokerSyncRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof syncFromBroker>>,
        TError,
        {data: ImportBrokerSyncRequest},
        TContext
      > => {

      const mutationOptions = getSyncFromBrokerMutationOptions(options);

      return useMutation(mutationOptions);
    }

/**
 * @summary Sync from an existing import source
 */
export const syncImportSource = (
    sourceId: string,
    syncImportSourceRequest: SyncImportSourceRequest,
    options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ImportResponse>> => {

    return axios.default.post(
      `/v2/imports/sources/${sourceId}/sync`,
      syncImportSourceRequest,
      options
    );
  }

export const getSyncImportSourceMutationOptions = <TError = AxiosError<ErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncImportSource>>, TError,{sourceId: string; data: SyncImportSourceRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof syncImportSource>>, TError,{sourceId: string; data: SyncImportSourceRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};



      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncImportSource>>, {sourceId: string; data: SyncImportSourceRequest}> = (props) => {
          const {sourceId, data} = props ?? {};

          return  syncImportSource(sourceId, data, axiosOptions)
        }




  return  { mutationFn, ...mutationOptions }}

export type SyncImportSourceMutationResult = NonNullable<Awaited<ReturnType<typeof syncImportSource>>>

export type SyncImportSourceMutationError = AxiosError<ErrorResponse | void>

    /**
 * @summary Sync from an existing import source
 */
export const useSyncImportSource = <TError = AxiosError<ErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncImportSource>>, TError,{sourceId: string; data: SyncImportSourceRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof syncImportSource>>,
        TError,
        {sourceId: string; data: SyncImportSourceRequest},
        TContext
      > => {

      const mutationOptions = getSyncImportSourceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary List import operations for the authenticated user
 */
export const listImportOperations = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ImportOperationResponse[]>> => {
    
    return axios.default.get(
      `/v2/imports/operations`,options
    );
  }


export const getListImportOperationsQueryKey = () => {
    return [`/v2/imports/operations`] as const;
    }

    
export const getListImportOperationsQueryOptions = <TData = Awaited<ReturnType<typeof listImportOperations>>, TError = AxiosError<void | ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listImportOperations>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListImportOperationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listImportOperations>>> = ({ signal }) => listImportOperations({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listImportOperations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListImportOperationsQueryResult = NonNullable<Awaited<ReturnType<typeof listImportOperations>>>
export type ListImportOperationsQueryError = AxiosError<void | ErrorResponse>

/**
 * @summary List import operations for the authenticated user
 */
export const useListImportOperations = <TData = Awaited<ReturnType<typeof listImportOperations>>, TError = AxiosError<void | ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listImportOperations>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getListImportOperationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get a specific import operation by ID
 */
export const getImportOperation = (
    importId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ImportOperationResponse>> => {
    
    return axios.default.get(
      `/v2/imports/operations/${importId}`,options
    );
  }


export const getGetImportOperationQueryKey = (importId: string,) => {
    return [`/v2/imports/operations/${importId}`] as const;
    }

    
export const getGetImportOperationQueryOptions = <TData = Awaited<ReturnType<typeof getImportOperation>>, TError = AxiosError<void | ErrorResponse>>(importId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImportOperation>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetImportOperationQueryKey(importId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getImportOperation>>> = ({ signal }) => getImportOperation(importId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(importId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getImportOperation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetImportOperationQueryResult = NonNullable<Awaited<ReturnType<typeof getImportOperation>>>
export type GetImportOperationQueryError = AxiosError<void | ErrorResponse>

/**
 * @summary Get a specific import operation by ID
 */
export const useGetImportOperation = <TData = Awaited<ReturnType<typeof getImportOperation>>, TError = AxiosError<void | ErrorResponse>>(
 importId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImportOperation>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetImportOperationQueryOptions(importId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Import a statement file
 */
export const importStatement = (
    apiImportStatementRequestSchema: ApiImportStatementRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ImportResponse>> => {const formData = new FormData();
formData.append('account_id', apiImportStatementRequestSchema.account_id)
if(apiImportStatementRequestSchema.broker !== undefined && apiImportStatementRequestSchema.broker !== null) {
 formData.append('broker', apiImportStatementRequestSchema.broker)
 }
if(apiImportStatementRequestSchema.timezone !== undefined && apiImportStatementRequestSchema.timezone !== null) {
 formData.append('timezone', apiImportStatementRequestSchema.timezone)
 }
if(apiImportStatementRequestSchema.start_date !== undefined && apiImportStatementRequestSchema.start_date !== null) {
 formData.append('start_date', apiImportStatementRequestSchema.start_date)
 }
formData.append('file', apiImportStatementRequestSchema.file)

    
    return axios.default.post(
      `/v2/imports/statement`,
      formData,options
    );
  }



export const getImportStatementMutationOptions = <TError = AxiosError<ErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importStatement>>, TError,{data: ApiImportStatementRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof importStatement>>, TError,{data: ApiImportStatementRequestSchema}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importStatement>>, {data: ApiImportStatementRequestSchema}> = (props) => {
          const {data} = props ?? {};

          return  importStatement(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImportStatementMutationResult = NonNullable<Awaited<ReturnType<typeof importStatement>>>
    export type ImportStatementMutationBody = ApiImportStatementRequestSchema
    export type ImportStatementMutationError = AxiosError<ErrorResponse | void>

    /**
 * @summary Import a statement file
 */
export const useImportStatement = <TError = AxiosError<ErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importStatement>>, TError,{data: ApiImportStatementRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof importStatement>>,
        TError,
        {data: ApiImportStatementRequestSchema},
        TContext
      > => {

      const mutationOptions = getImportStatementMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary List journal entries for the authenticated user
 */
export const listJournalEntries = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<JournalEntryResponse[]>> => {
    
    return axios.default.get(
      `/v2/journal`,options
    );
  }


export const getListJournalEntriesQueryKey = () => {
    return [`/v2/journal`] as const;
    }

    
export const getListJournalEntriesQueryOptions = <TData = Awaited<ReturnType<typeof listJournalEntries>>, TError = AxiosError<void | ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJournalEntries>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListJournalEntriesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listJournalEntries>>> = ({ signal }) => listJournalEntries({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listJournalEntries>>, TError, TData> & { queryKey: QueryKey }
}

export type ListJournalEntriesQueryResult = NonNullable<Awaited<ReturnType<typeof listJournalEntries>>>
export type ListJournalEntriesQueryError = AxiosError<void | ErrorResponse>

/**
 * @summary List journal entries for the authenticated user
 */
export const useListJournalEntries = <TData = Awaited<ReturnType<typeof listJournalEntries>>, TError = AxiosError<void | ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJournalEntries>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getListJournalEntriesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Delete all journal entries for the authenticated user
 */
export const deleteAllJournalEntries = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.delete(
      `/v2/journal/all`,options
    );
  }



export const getDeleteAllJournalEntriesMutationOptions = <TError = AxiosError<void | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAllJournalEntries>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAllJournalEntries>>, TError,void, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAllJournalEntries>>, void> = () => {
          

          return  deleteAllJournalEntries(axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAllJournalEntriesMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAllJournalEntries>>>
    
    export type DeleteAllJournalEntriesMutationError = AxiosError<void | ErrorResponse>

    /**
 * @summary Delete all journal entries for the authenticated user
 */
export const useDeleteAllJournalEntries = <TError = AxiosError<void | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAllJournalEntries>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteAllJournalEntries>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getDeleteAllJournalEntriesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get a journal entry by date
 */
export const getJournalEntry = (
    date: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<JournalEntryResponse>> => {
    
    return axios.default.get(
      `/v2/journal/${date}`,options
    );
  }


export const getGetJournalEntryQueryKey = (date: string,) => {
    return [`/v2/journal/${date}`] as const;
    }

    
export const getGetJournalEntryQueryOptions = <TData = Awaited<ReturnType<typeof getJournalEntry>>, TError = AxiosError<void | ErrorResponse>>(date: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJournalEntry>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJournalEntryQueryKey(date);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJournalEntry>>> = ({ signal }) => getJournalEntry(date, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(date), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJournalEntry>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJournalEntryQueryResult = NonNullable<Awaited<ReturnType<typeof getJournalEntry>>>
export type GetJournalEntryQueryError = AxiosError<void | ErrorResponse>

/**
 * @summary Get a journal entry by date
 */
export const useGetJournalEntry = <TData = Awaited<ReturnType<typeof getJournalEntry>>, TError = AxiosError<void | ErrorResponse>>(
 date: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJournalEntry>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetJournalEntryQueryOptions(date,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Create or update a journal entry
 */
export const createOrUpdateJournalEntry = (
    date: string,
    createOrUpdateJournalEntryRequest: CreateOrUpdateJournalEntryRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<JournalEntryResponse>> => {
    
    return axios.default.put(
      `/v2/journal/${date}`,
      createOrUpdateJournalEntryRequest,options
    );
  }



export const getCreateOrUpdateJournalEntryMutationOptions = <TError = AxiosError<ErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrUpdateJournalEntry>>, TError,{date: string;data: CreateOrUpdateJournalEntryRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createOrUpdateJournalEntry>>, TError,{date: string;data: CreateOrUpdateJournalEntryRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrUpdateJournalEntry>>, {date: string;data: CreateOrUpdateJournalEntryRequest}> = (props) => {
          const {date,data} = props ?? {};

          return  createOrUpdateJournalEntry(date,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateOrUpdateJournalEntryMutationResult = NonNullable<Awaited<ReturnType<typeof createOrUpdateJournalEntry>>>
    export type CreateOrUpdateJournalEntryMutationBody = CreateOrUpdateJournalEntryRequest
    export type CreateOrUpdateJournalEntryMutationError = AxiosError<ErrorResponse | void>

    /**
 * @summary Create or update a journal entry
 */
export const useCreateOrUpdateJournalEntry = <TError = AxiosError<ErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrUpdateJournalEntry>>, TError,{date: string;data: CreateOrUpdateJournalEntryRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof createOrUpdateJournalEntry>>,
        TError,
        {date: string;data: CreateOrUpdateJournalEntryRequest},
        TContext
      > => {

      const mutationOptions = getCreateOrUpdateJournalEntryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Delete a journal entry by date
 */
export const deleteJournalEntry = (
    date: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.delete(
      `/v2/journal/${date}`,options
    );
  }



export const getDeleteJournalEntryMutationOptions = <TError = AxiosError<void | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteJournalEntry>>, TError,{date: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteJournalEntry>>, TError,{date: string}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteJournalEntry>>, {date: string}> = (props) => {
          const {date} = props ?? {};

          return  deleteJournalEntry(date,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteJournalEntryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteJournalEntry>>>
    
    export type DeleteJournalEntryMutationError = AxiosError<void | ErrorResponse>

    /**
 * @summary Delete a journal entry by date
 */
export const useDeleteJournalEntry = <TError = AxiosError<void | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteJournalEntry>>, TError,{date: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteJournalEntry>>,
        TError,
        {date: string},
        TContext
      > => {

      const mutationOptions = getDeleteJournalEntryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get user settings
 */
export const getUserSettings = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserSettingsResponse>> => {
    
    return axios.default.get(
      `/v2/settings`,options
    );
  }


export const getGetUserSettingsQueryKey = () => {
    return [`/v2/settings`] as const;
    }

    
export const getGetUserSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getUserSettings>>, TError = AxiosError<void | ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSettings>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserSettingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserSettings>>> = ({ signal }) => getUserSettings({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserSettings>>>
export type GetUserSettingsQueryError = AxiosError<void | ErrorResponse>

/**
 * @summary Get user settings
 */
export const useGetUserSettings = <TData = Awaited<ReturnType<typeof getUserSettings>>, TError = AxiosError<void | ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSettings>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update user settings
 */
export const updateUserSettings = (
    updateUserSettingsRequest: UpdateUserSettingsRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserSettingsResponse>> => {
    
    return axios.default.put(
      `/v2/settings`,
      updateUserSettingsRequest,options
    );
  }



export const getUpdateUserSettingsMutationOptions = <TError = AxiosError<ErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserSettings>>, TError,{data: UpdateUserSettingsRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateUserSettings>>, TError,{data: UpdateUserSettingsRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserSettings>>, {data: UpdateUserSettingsRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateUserSettings(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserSettings>>>
    export type UpdateUserSettingsMutationBody = UpdateUserSettingsRequest
    export type UpdateUserSettingsMutationError = AxiosError<ErrorResponse | void>

    /**
 * @summary Update user settings
 */
export const useUpdateUserSettings = <TError = AxiosError<ErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserSettings>>, TError,{data: UpdateUserSettingsRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateUserSettings>>,
        TError,
        {data: UpdateUserSettingsRequest},
        TContext
      > => {

      const mutationOptions = getUpdateUserSettingsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Delete user settings
 */
export const deleteUserSettings = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.delete(
      `/v2/settings`,options
    );
  }



export const getDeleteUserSettingsMutationOptions = <TError = AxiosError<void | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserSettings>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserSettings>>, TError,void, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserSettings>>, void> = () => {
          

          return  deleteUserSettings(axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserSettings>>>
    
    export type DeleteUserSettingsMutationError = AxiosError<void | ErrorResponse>

    /**
 * @summary Delete user settings
 */
export const useDeleteUserSettings = <TError = AxiosError<void | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserSettings>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteUserSettings>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getDeleteUserSettingsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    